module.exports = __webpack_public_path__ + "static/media/infografia_galdisa_diabetes_en.28f1e1bd.jpg";